import { render } from "./PlusIcon.svg?vue&type=template&id=fcf7994a"
const script = {}
script.render = render

export default script